import { render } from "./IconShop.vue?vue&type=template&id=86033826"
import script from "./IconShop.vue?vue&type=script&lang=js"
export * from "./IconShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__